module.exports = __webpack_public_path__ + "img/business_1.bbf145d7.jpg";